import './calculation-loading.scss';

type CalculationLoadingProps = {
    title: string,
    message: string
}

export default function CalculationLoading({title, message}: CalculationLoadingProps) {
    return (
        <div className="calculation-loading" role="status" aria-live="polite" aria-busy="true">
            <span className="calculation-loading__spinner" aria-hidden="true" />
            <strong>{title}</strong>
            <span>{message}</span>
        </div>
    );
}
